import { formatterPrice } from 'src/utils/formatterPrice'

import { FreeShippingBadge } from './ShippingBadges'

export const FreightDetailsPrice = ({
  deliveryValue,
}: {
  deliveryValue: number | undefined | null
}) => {
  if (deliveryValue === undefined || deliveryValue === null) {
    return null
  }

  if (deliveryValue === 0) {
    return <FreeShippingBadge />
  }

  return (
    <p className="text-restructure-primary text-sm leading-[21px] font-regular">
      {formatterPrice(deliveryValue / 100)}
    </p>
  )
}
